import { useState, type FormEvent } from "react";
import { Link, useNavigate, useParams } from "react-router";
import { ApiError, post } from "../../lib/api";
import { Button } from "../../ui/Button";
import { ErrorSummary, TextField, useFieldError } from "../../ui/Field";
import { AuthLayout } from "./AuthLayout";

/** Parola sıfırlama: e-posta bağlantısı (/parola-sifirla/:token) veya İK'nın verdiği kod. */
export function ResetPage() {
  const { token } = useParams();
  return token ? <ResetConfirm initialToken={token} /> : <ResetRequest />;
}

function ResetRequest() {
  const [login, setLogin] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await post("/auth/password-reset/request", { login });
    } finally {
      setBusy(false);
      setSent(true);
    }
  }
  if (sent) {
    return (
      <AuthLayout title="İsteğiniz alındı" footer={<Link to="/parola-sifirla/kod">İK'dan kod aldıysanız buraya girin</Link>}>
        <p>Bu bilgiyle bir hesap varsa ve e-posta adresi kayıtlıysa sıfırlama bağlantısı gönderildi. E-postanız yoksa İK ekibinizden sıfırlama kodu isteyin.</p>
      </AuthLayout>
    );
  }
  return (
    <AuthLayout title="Parolanızı sıfırlayın" footer={<Link to="/giris">Giriş ekranına dön</Link>}>
      <form onSubmit={submit} className="form">
        <TextField label="E-posta veya cep telefonu" value={login} onChange={(e) => setLogin(e.target.value)} autoComplete="username" required />
        <Button type="submit" variant="primary" size="lg" busy={busy} className="btn--block">
          Sıfırlama bağlantısı gönder
        </Button>
        <p className="form__aside">
          <Link to="/parola-sifirla/kod">İK'dan sıfırlama kodu aldım</Link>
        </p>
      </form>
    </AuthLayout>
  );
}

function ResetConfirm({ initialToken }: { initialToken: string }) {
  const [token, setToken] = useState(initialToken === "kod" ? "" : initialToken);
  const [password, setPassword] = useState("");
  const [error, setError] = useState<ApiError | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();
  const fe = useFieldError();
  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await post("/auth/password-reset/confirm", { token, password });
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiError ? err : null);
    } finally {
      setBusy(false);
    }
  }
  if (done) {
    return (
      <AuthLayout title="Parolanız değişti">
        <p>Güvenliğiniz için diğer cihazlardaki oturumlar kapatıldı.</p>
        <Button variant="primary" size="lg" className="btn--block" onClick={() => navigate("/giris")}>
          Giriş yap
        </Button>
      </AuthLayout>
    );
  }
  return (
    <AuthLayout title="Yeni parola belirleyin">
      <form onSubmit={submit} noValidate className="form">
        <ErrorSummary message={error?.message} fields={error?.fields} />
        {initialToken === "kod" && <TextField label="Sıfırlama kodu" value={token} onChange={(e) => setToken(e.target.value)} autoComplete="one-time-code" error={fe(error?.fields.token)} required />}
        <TextField label="Yeni parola" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" hint="En az 10 karakter." error={fe(error?.fields.password)} required />
        <Button type="submit" variant="primary" size="lg" busy={busy} className="btn--block">
          Parolayı değiştir
        </Button>
      </form>
    </AuthLayout>
  );
}
